import { createClient, ContentfulClientApi } from 'contentful';

let client: ContentfulClientApi<undefined>;
let previewClient: ContentfulClientApi<undefined>;

export const getClient = (preview: boolean) => {
    if (preview) {
        if (!previewClient) {
            previewClient = createClient({
                space: process.env['NEXT_PUBLIC_CONTENTFUL_SPACE_ID'] || '',
                accessToken: process.env['NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN'] || '',
                environment: process.env['NEXT_PUBLIC_CONTENTFUL_ENV'] || 'master',
                host: 'preview.contentful.com',
            });
        }
        return previewClient;
    }

    if (!client) {
        client = createClient({
            space: process.env['NEXT_PUBLIC_CONTENTFUL_SPACE_ID'] || '',
            accessToken:
                process.env['CONTENTFUL_ACCESS_TOKEN'] || process.env['NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN'] || '',
            environment: process.env['NEXT_PUBLIC_CONTENTFUL_ENV'] || 'master',
        });
    }
    return client;
};
